<template>
  <Form :mapState="'adminUsers'" :typeEndPoint="this.typeEndPoint" :dataParams="this.dataParams"></Form>
</template>
<script>
import Form from '@/components/modules/base/form.vue'
export default {
  name: 'Forms',
  components: {
    Form
  },
  props: {
    typeEndPoint: { required: true },
    dataParams: {}
  },
  methods: {
  productsSelect: function () {
      let json = JSON.stringify(this.$route.params)
      this.$store.dispatch('inventoryProductsRestauran', json).then(response => {
        this.code = this.$store.getters.adminUsers
        if(this.varReload == null){          
          this.varReload = setInterval(this.search, 50000)      
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/admin/users/form.vue